// extracted by mini-css-extract-plugin
export default {"total":"ReceivableNotificationBuildModal_total__LTpNK","document":"ReceivableNotificationBuildModal_document__0GR6j"};